import React from "react";
import { Chip, TextField } from "@material-ui/core";
import classnames from 'classnames';
import Autocomplete from "@material-ui/lab/Autocomplete";
import classes from "./ChipInput.module.scss";

interface ChipInputProps {
	placeholderText?: string;
	className?: string;
	onChange?: (val:string[]) => void;
	onInputChange?: (val:string) => void;
	values?: string[];
	textInputRef?: React.Ref<any>;
}

const ChipInput: React.FC<ChipInputProps> = ({ 
	placeholderText,
	onChange,
	onInputChange,
	values,
	textInputRef,
	className:propsClassName,
 }) => {
	const [inputValue, setInputValue] = React.useState("");

	const onChangeEvent = (e, newValue) => {
			if(e.key === "Enter"){
				cleanAndAdd(inputValue);
			} else {
				onChange?.(newValue);
			}
	};

	const checkForTriggerKeys = (val) => {
		onInputChange?.(val);
		// current trigger keys are comma or space
		const removedTriggerKeys = val.split(/[ ,]+/);
		if (removedTriggerKeys.length > 1) {
			cleanAndAdd(removedTriggerKeys[0])
		} else {
			setInputValue(val);
		}
	}

	const cleanAndAdd = (item) => {
		let cleanVal = item.replace(/[^a-zA-Z0-9]/g, '')
		let cleanLowerCase = cleanVal.toLowerCase();
		if(values){
			if(values.includes(cleanLowerCase) || cleanLowerCase === ''){			
	
				setInputValue("");
				onChange?.([...values]);
			} else {
	
				let newVal = [...values, cleanLowerCase].filter((x) => x)
				onChange?.(newVal);
			}
		}
	}
  const placeholder = (values?.length === 0 && placeholderText) ? placeholderText : '';
  return (
    <div className={classnames(classes.chipInput, propsClassName)}>
      <Autocomplete
        multiple
        id="chip-input"
        options={[]}
        freeSolo
        value={values}
        onChange={(event, newInputValue) => {
          onChangeEvent(event, newInputValue);
        }}
        onInputChange={(_event, newInputValue) => {checkForTriggerKeys(newInputValue)}}
        renderTags={(values, getTagProps) =>
          values.map((option, index) => (
            <Chip
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
			inputRef={textInputRef}
            {...params}
			multiline
            placeholder={placeholder}
			InputProps={{...params.InputProps, disableUnderline: true, classes: { root: classes.inputRoot, focused: classes.inputRootFocused }}}
          />
        )}
      />
    </div>
  );
};
export default ChipInput;
